<div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

        <!-- <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'id' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.id}} </td>
        </ng-container> -->

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'name' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.name}} </td>
        </ng-container>

        <ng-container matColumnDef="userName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'userName' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.userName}} </td>
        </ng-container>

        <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'role' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.role.toLowerCase() | translate}} </td>
        </ng-container>


        <ng-container matColumnDef="options">
            <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'options' | translate}} </th>
            <td mat-cell *matCellDef="let row;let i = index;" style="width: 10%;padding: 10px;">
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="onActiveAndDeactivate(row)">

                        <mat-icon *ngIf="row.approved == 0">done</mat-icon>
                        <mat-icon *ngIf="row.approved == 1">block</mat-icon>

                        <span *ngIf="row.approved == 1 ">{{'unActive' | translate}}</span>
                        <span *ngIf="row.approved == 0 ">{{'activate' | translate}}</span>


                    </button>

                    <button mat-menu-item (click)="onChangeRole(row)">
                        <mat-icon>loop</mat-icon>
                        {{'changeRole' | translate}}
                    </button>

                    <button mat-menu-item (click)="resetPassword(row)">
                        <mat-icon>security</mat-icon>
                        {{'resetPassword' | translate}}
                    </button>

                    <button mat-menu-item (click)="onDelete(row)">
                        <mat-icon>delete</mat-icon>
                        {{'delete' | translate}}
                    </button>

                    <!-- <button mat-menu-item (click)="onDeactivate(row.id,row.approved)">

                        <mat-icon *ngIf="selectedStatus == 0">done</mat-icon>
                        <mat-icon *ngIf="selectedStatus == 1">block</mat-icon>

                        <span *ngIf="selectedStatus == 1 ">{{'unActive' | translate}}</span>
                        <span *ngIf="selectedStatus == 0 ">{{'activate' | translate}}</span>


                    </button> -->

                    <!-- <button mat-menu-item (click)="resetPassword(row)">
                  <mat-icon>security</mat-icon>
                  {{'resetPassword' | translate}}
                </button>
    
                <button mat-menu-item (click)="assignAssMandoob(row)">
                  <mat-icon>assignment_ind</mat-icon>
                  {{'assignAsMandoob' | translate}}
                </button> -->

                </mat-menu>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}} </td>
        </tr>
    </table>

    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>

<ng-template #ModalNewRole>

    <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
    <div mat-dialog-content>
        <p>{{'selectNewRole' | translate}}</p>
        <mat-form-field appearance="standard">
            <mat-label>{{'role' | translate}}</mat-label>
            <mat-select [(value)]="selectedRole">
                <mat-option *ngFor="let role of roles" [value]="role.id">
                    {{role.name | translate}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <br />
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-raised-button color="primary" (click)="confirmChangeRole()">{{'confirm' | translate}}</button>
    </div>

</ng-template>

<ng-template #ModalConfirmReset>

    <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
    <div mat-dialog-content>
        <p>{{'areYouSureToResetPassword' | translate}}
            <br />
            {{userfullName}}
        </p>

    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-raised-button color="primary" cdkFocusInitial (click)="confirmReset()">{{'yes' |
            translate}}</button>
    </div>

</ng-template>

<ng-template #ModalNewPassword>

    <h1 mat-dialog-title>{{'newPassword' | translate}}</h1>
    <div mat-dialog-content>
        <p style="font-weight: bolder;">
            {{newPassword}}
        </p>

    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
    </div>

</ng-template>

<ng-template #ModalConfirmDelete>

    <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
    <div mat-dialog-content>
        <p>{{'areYouSureToDelete' | translate}}</p>

    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-button cdkFocusInitial (click)="confirmDelete()">{{'yes' | translate}}</button>
    </div>

</ng-template>

<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>